<div class="inventory-container">
    <h1 class="inventory-title">{{ itemName }}</h1>

    <div class="inventory-body">
        <p class="inventory-stock">Stock: {{ stock }}</p>
        <p class="inventory-expire-date">Expire: {{ expirationDate }}</p>
    </div>
    <div class="stock-status" [ngClass]="getStatusClass(stockStatus)">
        {{ stockStatus }}
    </div>
</div>
